import { computed } from 'vue'
import { Locale } from 'wot-design-uni/locale'
import i18n from '../locales'
import zhCN from 'wot-design-uni/locale/lang/zh-CN'
import enUS from 'wot-design-uni/locale/lang/en-US'
const SUPPORTED_LOCALES = ['zh-Hans', 'en']
const TABBAR_LIST = [
  {
    index: 0,
    text: 'shouYe',
    pagePath: 'pages/index/index',
  },
  {
    index: 1,
    text: 'ziXun',
    pagePath: 'pages/information/index',
  },
  {
    index: 2,
    text: 'huoPan',
    pagePath: 'pages/product/index',
  },
  {
    index: 3,
    text: 'caiGouChe',
    pagePath: 'pages/shoppingCart/shoppingCart',
  },
  {
    index: 4,
    text: 'woDe',
    pagePath: 'pages/user/index',
  },
]
function setLocale(locale: string, syncComponentLib: boolean = true) {
  console.log(locale, 'locale====')
  if (!SUPPORTED_LOCALES.includes(locale)) {
    console.warn(`不支持的语言: ${locale}，将使用默认语言 zh-Hans`)
    locale = 'zh-Hans'
  }
  uni.setLocale(locale)
  // 修复：确保 i18n 全局语言设置与传入的 locale 一致
  i18n.global.locale.value = locale
  uni.setStorageSync('currentLang', locale)
  if (syncComponentLib) {
    Locale.use(locale, locale === 'zh-Hans' ? zhCN : enUS)
  }
  return locale
}
function setTabbarI18n() {
  TABBAR_LIST.forEach((item) => {
    uni.setTabBarItem({
      index: item.index,
      text: i18n.global.t(item.text),
      pagePath: item.pagePath,
    })
  })
}

export function useI18nSync() {
  return {
    currentLang: computed(() => uni.getStorageSync('currentLang') || i18n.global.locale.value),
    setLocale: (locale?: string, syncComponentLib = true) => setLocale(locale, syncComponentLib),
    supportedLocales: SUPPORTED_LOCALES,
    setTabbarI18n,
  }
}
